module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_arvidsjaur-ad366a57b8cab0f6f58705b85d050e1a.png";